import $ from "jquery"

console.log("test-primary")

$(document).on('click', '.test', function(e) {
    e.preventDefault();
    console.log("test");
})
